import { useState, useContext } from 'react';
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { MobileTopBar } from './mobile/MobileTopBar';
import { MobileBottomNavigation } from './mobile/BottomNavigation';
import { MobileDrawer } from './mobile/MobileDrawer';
import { ColorModeContext } from '../contexts/ColorModeContext';
import { useZoom } from '../contexts/ZoomContext';
import { useMobile } from '../hooks/useMobile';
import { useMobileNavigation } from '../contexts/MobileNavigationContext';
import { mobileTokens } from '../theme/mobileTokens';
import { palette } from '../theme/colors';

const HEADER_HEIGHT = 56;

export const Layout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { mode } = useContext(ColorModeContext);
  const { zoomContainerStyle } = useZoom();
  const { isMobile } = useMobile();
  const { drawerOpen, closeDrawer } = useMobileNavigation();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const bgColor = mode === 'dark' ? palette.background : palette.light.background;

  // Calculate padding for mobile navigation
  const mainContentPadding = isMobile
    ? {
        pt: `${mobileTokens.topBar.height + 16}px`, // Top bar + spacing
        pb: `calc(${mobileTokens.bottomNav.height}px + ${mobileTokens.spacing['2xl']}px + ${mobileTokens.safeArea.bottom})`, // Bottom nav + extra spacing for labels + iOS safe area
        px: 2,
      }
    : {
        mt: `${HEADER_HEIGHT}px`,
        p: { xs: 2, sm: 3 },
      };

  return (
    <>
      {/* Fixed Mobile Navigation - OUTSIDE zoom container to preserve fixed positioning */}
      {isMobile && (
        <>
          <MobileTopBar
            notificationCount={0}
            userName=""
            onNotificationClick={() => {}}
            onAvatarClick={() => {}}
          />
          <MobileDrawer
            open={drawerOpen}
            onClose={closeDrawer}
            userName=""
            userEmail=""
            onLogout={() => {}}
          />
          <MobileBottomNavigation />
        </>
      )}

      {/* Zoomed Content Container */}
      <Box
        sx={{
          ...zoomContainerStyle,
          display: 'flex',
          minHeight: zoomContainerStyle.minHeight || '100vh',
          backgroundColor: bgColor,
        }}
      >
        {/* Desktop Navigation */}
        {!isMobile && (
          <>
            <Sidebar mobileOpen={mobileOpen} onMobileClose={() => setMobileOpen(false)} />
            <Header onMenuClick={handleDrawerToggle} />
          </>
        )}

        {/* Main Content Area */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            ...mainContentPadding,
            minHeight: isMobile
              ? 'auto' // Let content expand naturally with bottom padding
              : `calc(100vh - ${HEADER_HEIGHT}px)`,
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </>
  );
};
